// Ported from dev-scrips-pm-react src/scheduling/components/appointments/cancellation-note-field.tsx (PROD-3313).
// PM draws a local Label + Textarea + its own "n/500" counter; here the DS TextArea carries the label and, given
// `maxLength`, draws the same counter itself.
import { TextArea } from '@scripsteam/scrips-signal-ds';
import { CANCELLATION_NOTE_MAX } from '@/scheduling/lib/cancellation-note';

interface CancellationNoteFieldProps {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
}

/** Optional free-text "Note" for a single-appointment cancel. */
export function CancellationNoteField({ value, onChange, disabled }: CancellationNoteFieldProps) {
  return (
    <TextArea
      id="cancel-note"
      label="Note (optional)"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      maxLength={CANCELLATION_NOTE_MAX}
      rows={3}
      disabled={disabled}
      placeholder="Add a note about this cancellation"
    />
  );
}
